module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBigH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBigH.svg
// module id = 237
// module chunks = 0